(() => {
  let stopRapidSizeSync;
  function startRapidSizeSync(main, variants) {
    if (location.pathname.replace(/\/$/, '') !== '/products/culotte-gainante-taille-haute-compression-360') return () => {};
    const productId = '16386428305743';
    const sizeSelector = 'select[data-variantname="Taille"]';
    const rowSelector = '.rapi-bundles__bar-variant';
    const controller = new AbortController();
    let selectedKey = null;
    let armed = true;
    let generation = 0;
    let disposed = false;
    const widget = () => main.querySelector('[data-rapi-id][product-id="' + productId + '"]')?.closest('.shopify-app-block');
    const selectedPack = () => {
      const root = widget();
      const radio = root?.querySelector('.rapi-bundles__bar > input[type="radio"]:checked');
      if (!radio || radio.name !== 'rapi-bundles-deal-' + productId) return null;
      return { root, bar: radio.closest('.rapi-bundles__bar'), key: radio.id };
    };
    const refreshPack = () => {
      const pack = selectedPack();
      if (pack && pack.key !== selectedKey) {
        selectedKey = pack.key;
        armed = true;
        generation++;
      }
      return pack;
    };
    const colorOf = row => row.querySelector('.rapi-dropdown-text')?.textContent.trim()
      || row.querySelector('select[data-variantname="Couleur"]')?.value;
    const canSelect = (row, size) => {
      const select = row.querySelector(sizeSelector);
      const color = colorOf(row);
      return select && !select.disabled
        && [...select.options].some(option => option.value === size && !option.disabled)
        && variants.some(variant => variant.available && variant.options[0] === color && variant.options[1] === size);
    };
    const frame = () => new Promise(resolve => requestAnimationFrame(resolve));
    const synchronize = async (key, sourceIndex, size, ticket) => {
      await frame();
      let pack = selectedPack();
      if (disposed || generation !== ticket || pack?.key !== key) return;
      const count = pack.bar.querySelectorAll(rowSelector).length;
      for (let index = 0; index < count; index++) {
        if (disposed || generation !== ticket) return;
        pack = selectedPack();
        if (pack?.key !== key) return;
        if (index === sourceIndex) continue;
        const row = pack.bar.querySelectorAll(rowSelector)[index];
        if (!row || !canSelect(row, size)) continue;
        const select = row.querySelector(sizeSelector);
        if (select.value === size) continue;
        select.value = size;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        await frame();
      }
    };
    main.addEventListener('change', event => {
      if (!(event.target instanceof HTMLSelectElement) || !event.target.matches(sizeSelector) || !event.isTrusted) return;
      const pack = refreshPack();
      if (!pack || !pack.bar.contains(event.target)) return;
      const row = event.target.closest(rowSelector);
      const sourceIndex = [...pack.bar.querySelectorAll(rowSelector)].indexOf(row);
      if (sourceIndex < 0) return;
      generation++;
      if (!armed) return;
      armed = false;
      if (!canSelect(row, event.target.value)) return;
      void synchronize(pack.key, sourceIndex, event.target.value, generation);
    }, { capture: true, signal: controller.signal });
    main.addEventListener('click', event => {
      if (event.target instanceof Element && widget()?.contains(event.target)) queueMicrotask(refreshPack);
    }, { capture: true, signal: controller.signal });
    const observer = new MutationObserver(refreshPack);
    observer.observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked'] });
    refreshPack();
    return () => {
      disposed = true;
      generation++;
      observer.disconnect();
      controller.abort();
    };
  }

  function init() {
    const main = document.querySelector('[id^="MainProduct-"]:has(.arlaya-copy)');
    if (!main || main.dataset.arlayaBound) return;
    main.dataset.arlayaBound = 'true';
    document.querySelector('[data-arlaya-sticky-price]')?.remove();
    main.querySelectorAll('.accordion__details,.arlaya-return').forEach(details=>details.removeAttribute('open'));
    const guarantee=main.querySelector('.arlaya-fit-promise');
    if(guarantee){guarantee.textContent='SATISFAITE OU REMBOURSÉE 90J';guarantee.style.cssText='display:block;text-align:center;color:#3a014c;font-weight:700;padding:16px 10px';}
    const offerHeading=main.querySelector('.arlaya-summer-sale');
    if(offerHeading){offerHeading.setAttribute('aria-label','Offres Black Friday');offerHeading.querySelector('.arlaya-summer-sale__season').textContent='BLACK FRIDAY';offerHeading.querySelector('.arlaya-summer-sale__tagline')?.remove();}
    const money = cents => new Intl.NumberFormat('fr-FR', {style:'currency',currency:'EUR'}).format(cents / 100);
    const form = main.querySelector('product-form form');
    const add = form?.querySelector('[name="add"]');
    const guide = document.querySelector('#arlaya-size-dialog');
    const videoDialog = document.querySelector('#arlaya-video-dialog');
    const sticky = document.querySelector('[data-arlaya-sticky]');
    const variantData=JSON.parse(main.querySelector('[data-arlaya-variants]')?.textContent||'[]');
    stopRapidSizeSync?.();
    stopRapidSizeSync=startRapidSizeSync(main, variantData);
    main.querySelectorAll('[data-arlaya-option]').forEach(select=>select.addEventListener('change',()=>{
      const options=[...main.querySelectorAll('[data-arlaya-option]')].map(el=>el.value);
      const variant=variantData.find(v=>v.options.every((option,index)=>option===options[index]));
      if(!variant||!form)return;
      const input=form.querySelector('[name="id"]');input.value=variant.id;input.setAttribute('value',variant.id);input.dispatchEvent(new Event('change',{bubbles:true}));
      add.disabled=!variant.available;add.querySelector('span').textContent=variant.available?'AJOUTER AU PANIER':'ÉPUISÉ';
      const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
      if(variant.featured_media){const media=main.querySelector(`button[data-target$="-${variant.featured_media.id}"]`);media?.click();}
    }));
    let activeVideo;
    document.querySelectorAll('[data-arlaya-size-open]').forEach(button => button.addEventListener('click', () => guide?.showModal()));
    document.querySelectorAll('[data-arlaya-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog').close()));
    document.querySelectorAll('.arlaya-copy dialog').forEach(dialog => {
      dialog.addEventListener('click', event => {if (event.target === dialog) {const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      dialog.addEventListener('close', () => {dialog.querySelectorAll('video').forEach(video => video.pause());});
    });
    document.querySelectorAll('[data-arlaya-slider]').forEach(slider => {
      const track=slider.querySelector('.swiper-wrapper');
      if (!track) return;
      const slides=[...track.children];
      const scope=slider.closest('.shopify-section');
      const pagination=scope?.querySelector('.swiper-pagination');
      const next=scope?.querySelector('[class*="btn-next-"]');
      const prev=scope?.querySelector('[class*="btn-prev-"]');
      if(slides.length>1 && pagination) slides.forEach((slide,index)=>{
        const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',`Voir le témoignage ${index+1}`);button.setAttribute('aria-current',index===0?'true':'false');
        button.addEventListener('click',()=>track.scrollTo({left:slide.offsetLeft-slides[0].offsetLeft,behavior:'smooth'}));pagination.append(button);
      });
      const step=()=>slides[1]?slides[1].offsetLeft-slides[0].offsetLeft:track.clientWidth;
      const updateReviewNavigation=()=>{
        if(slider.dataset.arlayaSlider!=='review')return;
        const start=track.scrollLeft<2,end=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;
        if(prev){prev.setAttribute('aria-label','Avis précédent');prev.disabled=start;prev.style.visibility=start?'hidden':'visible';}
        if(next){next.setAttribute('aria-label','Avis suivant');next.disabled=end;next.style.visibility=end?'hidden':'visible';}
      };
      updateReviewNavigation();
      next?.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));
      prev?.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));
      track.addEventListener('scroll',()=>{
        updateReviewNavigation();
        if(pagination){const index=Math.round(track.scrollLeft/step());[...pagination.children].forEach((b,i)=>b.setAttribute('aria-current',i===index?'true':'false'));}
      },{passive:true});
      slider.classList.remove('preview');
    });
    document.querySelectorAll('[data-arlaya-video]').forEach(slide=>{
      const preview=slide.querySelector('video');
      if(preview){
        preview.muted=true;preview.defaultMuted=true;preview.playsInline=true;preview.loop=true;preview.autoplay=true;preview.controls=false;preview.preload='auto';
        preview.setAttribute('muted','');preview.setAttribute('playsinline','');preview.setAttribute('webkit-playsinline','');preview.setAttribute('autoplay','');preview.setAttribute('data-arlaya-autoplay','');
        preview.removeAttribute('data-src');preview.classList.remove('lazy');
      }
      slide.setAttribute('role','button');slide.setAttribute('tabindex','0');slide.setAttribute('aria-label','Lire le témoignage vidéo');
      const open=()=>{if(!videoDialog)return;const video=videoDialog.querySelector('video');video.src=slide.dataset.arlayaVideo;videoDialog.showModal();video.play().catch(()=>{});activeVideo=video;};
      slide.addEventListener('click',open);slide.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();open();}});
    });
    const autoplayObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{const video=entry.target;video.muted=true;if(entry.isIntersecting)video.play().catch(()=>{});else video.pause();}),{rootMargin:'100px',threshold:.1});
    document.querySelectorAll('[data-arlaya-autoplay]').forEach(video=>autoplayObserver.observe(video));
    document.querySelectorAll('[data-arlaya-faq]').forEach(question=>{
      question.classList.add('mobile-font');question.closest('.faq-item')?.querySelector('.faq-answer')?.classList.add('mobile-font');
      const toggle=()=>{const item=question.closest('.faq-item'),active=item.classList.contains('active');document.querySelectorAll('.arlaya-copy .faq-item.active').forEach(el=>{el.classList.remove('active');el.querySelector('.faq-question')?.setAttribute('aria-expanded','false');});item.classList.toggle('active',!active);question.setAttribute('aria-expanded',String(!active));};
      question.addEventListener('click',toggle);question.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();toggle();}});
    });
    document.querySelector('[data-arlaya-sticky-buy]')?.addEventListener('click',()=>{
      const rect=add?.getBoundingClientRect();
      if(rect && rect.top>=0 && rect.bottom<=window.innerHeight && !add.disabled){add.click();return;}
      document.querySelector('#arlaya-buy')?.scrollIntoView({behavior:'smooth',block:'center'});
    });
    document.querySelector('[data-arlaya-top]')?.addEventListener('click',()=>window.scrollTo({top:0,behavior:'smooth'}));
    const rating=document.querySelector('#hc-wrap-block');
    const toReviews=()=>document.querySelector('[data-arlaya-slider="testimonials"]')?.scrollIntoView({behavior:'smooth',block:'center'});
    rating?.addEventListener('click',toReviews);rating?.addEventListener('keydown',e=>{if(e.key==='Enter')toReviews();});
    const gallery=main.querySelector('[id^="GalleryViewer-"]');
    if(gallery){
      gallery.classList.add('arlaya-gallery');gallery.insertAdjacentHTML('beforeend','<button type="button" class="arlaya-gallery-arrow arlaya-gallery-prev" aria-label="Image précédente">‹</button><button type="button" class="arlaya-gallery-arrow arlaya-gallery-next" aria-label="Image suivante">›</button>');
      const move=direction=>{const thumbs=[...main.querySelectorAll('[id^="GalleryThumbnails-"] button.thumbnail')];const current=Math.max(0,thumbs.findIndex(t=>t.getAttribute('aria-current')==='true'));thumbs[(current+direction+thumbs.length)%thumbs.length]?.click();};
      gallery.querySelector('.arlaya-gallery-prev').addEventListener('click',()=>move(-1));gallery.querySelector('.arlaya-gallery-next').addEventListener('click',()=>move(1));
    }
    const updatePrice=()=>{
      const id=form?.querySelector('[name="id"]')?.value;
      const data=main.querySelector('[data-arlaya-variants]');
      if(!data)return;
      const variants=JSON.parse(data.textContent);const variant=variants.find(v=>String(v.id)===id)||variants[0];if(!variant)return;
      document.querySelectorAll('[data-arlaya-price],[data-arlaya-sticky-price]').forEach(el=>el.textContent=money(variant.price));
      document.querySelectorAll('[data-arlaya-compare]').forEach(el=>{el.textContent=money(variant.compare_at_price||4299);});
      document.querySelectorAll('[data-arlaya-installment]').forEach(el=>el.textContent=`(${money(Math.floor(variant.price/3))} × 3)`);
    };
    main.addEventListener('change',()=>setTimeout(updatePrice,250));
    if(form)new MutationObserver(updatePrice).observe(form,{subtree:true,attributes:true,attributeFilter:['value']});
    updatePrice();
    if(add && sticky){
      let pending=false;
      const updateSticky=()=>{
        pending=false;
        sticky.classList.toggle('is-hidden',add.getBoundingClientRect().bottom>0);
        document.querySelector('[data-arlaya-top]')?.classList.toggle('is-hidden',window.scrollY<500);
      };
      const requestUpdate=()=>{if(!pending){pending=true;requestAnimationFrame(updateSticky);}};
      window.addEventListener('scroll',requestUpdate,{passive:true});
      window.addEventListener('resize',requestUpdate,{passive:true});
      new IntersectionObserver(requestUpdate,{threshold:[0,1]}).observe(add);
      updateSticky();
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',()=>{const main=document.querySelector('[id^="MainProduct-"]');if(main)delete main.dataset.arlayaBound;init();});
})();




